if (!customElements.get("quantity-price-table")) {
  customElements.define(
    "quantity-price-table",
    class QtyTierTable extends HTMLElement {
      constructor() {
        super();
        var btn = this.querySelector("[data-quantity-price-toggle]");
        var self = this;
        if (btn)
          btn.addEventListener("click", function () {
            self.toggle();
          });
      }

      connectedCallback() {
        var self = this;
        var sectionId = this.getAttribute("data-section");
        if (!sectionId) return;
        var qtyWrapper = document.getElementById(
          "quantity-wrapper-" + sectionId,
        );
        if (!qtyWrapper) return;
        var input = qtyWrapper.querySelector('input[name="quantity"]');
        if (!input) return;
        var container = this.closest("[data-quantity-price-block]");

        function getTotal() {
          var cartQty = container
            ? parseInt(
                container.getAttribute("data-cart-quantity") || "0",
                10,
              ) || 0
            : 0;
          return cartQty + (parseInt(input.value, 10) || 1);
        }

        self.highlightActiveTier(getTotal());
        input.addEventListener("input", function () {
          self.highlightActiveTier(getTotal());
        });
        input.addEventListener("change", function () {
          self.highlightActiveTier(getTotal());
        });
      }

      highlightActiveTier(qty) {
        var rows = this.querySelectorAll("[data-quantity]");
        var activeRow = null;
        rows.forEach(function (row) {
          row.classList.remove("quantity-price-row--active");
          if (qty >= parseInt(row.getAttribute("data-quantity") || "0", 10))
            activeRow = row;
        });
        if (activeRow) activeRow.classList.add("quantity-price-row--active");
      }

      toggle() {
        this.classList.toggle("quantity-price-table--open");
        var btn = this.querySelector("[data-quantity-price-toggle]");
        if (btn)
          btn.setAttribute(
            "aria-expanded",
            this.classList.contains("quantity-price-table--open"),
          );
      }
    },
  );
}
